<div class="ap-date__calendar__controls">
    <button
        type="button"
        class="ap-date__controls--nav prev"
        (click)="previousClicked()"
        [attr.aria-label]="prevButtonLabel"
        data-testid="previous-button"
        cdkMonitorElementFocus
    >
        <ap-icon name="chevron-left"></ap-icon>
    </button>

    <button
        type="button"
        class="ap-date__controls--current"
        (click)="currentPeriodClicked()"
        [attr.aria-label]="periodButtonLabel"
        data-testid="current-button"
        cdkMonitorElementFocus
        cdkAriaLive="polite"
        [tabIndex]="calendar.currentView !== 'multi-year' ? 0 : -1"
    >
        <h3 [class.ap-date__controls--clickable]="calendar.currentView !== 'multi-year'">
            {{ periodButtonText }}
        </h3>
    </button>

    <button
        type="button"
        class="ap-date__controls--nav next"
        (click)="nextClicked()"
        [attr.aria-label]="nextButtonLabel"
        data-testid="next-button"
        cdkMonitorElementFocus
    >
        <ap-icon name="chevron-right"></ap-icon>
    </button>
</div>
